/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_Outcome_UnknownInputs */

const vi_error_irrigation_outcome_unknown = /** @type {(inputs: Error_Irrigation_Outcome_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa rõ lệnh đã tới thiết bị hay chưa. Đừng bấm lại ngay: chờ vài giây xem trạng thái bơm cập nhật.`)
};

/**

* @param {Error_Irrigation_Outcome_UnknownInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_outcome_unknown = /** @type {((inputs?: Error_Irrigation_Outcome_UnknownInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_Outcome_UnknownInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_outcome_unknown(inputs)
});